import CardSection from 'components/common/CardSection';
import React from 'react';
import EnquiriesSummary from './EnquiriesSummary';
import EnquiriesTable from './EnquiriesTable';

const ParentEnquiries = () => (
  <CardSection title="enquiries.header">
    <EnquiriesSummary />
    <EnquiriesTable />
  </CardSection>
);

export default ParentEnquiries;
